// extracted by mini-css-extract-plugin
module.exports = {"container":"_3a5fMNi8-PvMLIwSEcSABY","cancelBtn":"_1iksHFCgKBSKj9I2QvlOpR","icon":"_2u1qh-BC1KJ5CVYNR2PX-x","saveBtn":"LTFiBB6n7iFYmOdOV6Uso"};